export default __webpack_public_path__ + "static/media/home.c55312da.svg";